import React, { Component } from "react";
import { Form } from "informed";
import EditText from "../../common/form-fields/edit-text/EditText";
import DropDownSelect from "../../common/form-fields/drop-down/DropDownSelect";
import TableComponent from "./../../common/table-component/TableComponent";
import ModalDialog from "../../common/modal-dialog/ModalDialog";
import { UncontrolledCollapse } from "reactstrap";
import "./AddClaim.css";
import MaskValidateUtil from "../../common/util/MaskValidateUtil";

export default class AddClaimDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feeInfoModal: false
    };

    this.claimTableRef = React.createRef();
  }

  toggleFeeInfoModal() {
    let currentState = this.state.feeInfoModal;
    this.setState({ feeInfoModal: !currentState });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.petDetails !== state.petDetails) {
      //If the user has only one pet , it has to be selected by default
      const selectedPet =
        props.petDetails.length === 1 ? props.petDetails[0].PetID : "";
      const showUploadVeterinaryInvoice = selectedPet === "" ? false : true;
      return {
        petDetails: props.petDetails,
        selectedPet,
        showUploadVeterinaryInvoice
      };
    }
    return null;
  }

  sendClaimFormData = formValues => {
    const dateError = formValues.dateOfService && MaskValidateUtil.OptionalValidateDateWithNow(formValues.dateOfService);
    this.props.addClaimDetails(formValues, dateError);
  };



  skipClickHandler = (evt) => {
    this.claimTableRef.current.resetTableSelectedData();
    this.props.addClaimDetailsSkip(evt);    
    evt.stopPropagation();
  }

  addClaimFromHeader = () => {
    return this.props.relatedClaims.length > 0 ? (
      <div className="mb-4">
        {/* TODO: Link proper URL. */}
        <p className="d-none d-md-block">
          By providing this you are helping us process your claim.
        </p>
        <p className="mb-0">
          <span className="sub-title-file-claim">
            <strong>a. Add Claim Detail</strong>
          </span>

          <a
            style={{ verticalAlign: "text-bottom" }}
            className="ml-1"
            href={process.env.REACT_APP_BASEURL+"/PolicyDocuments/INVOICE-%20EXAMPLE-Claim_Details.pdf"}
            target="_blank"
            rel="noopener noreferrer"
          >
            See sample invoice
          </a>
          <i
            style={{ marginTop: 3, verticalAlign: "text-top" }}
            className="ml-1 fa fa-question-circle text-secondary"
          />
        </p>
      </div>
    ) : (
      <div className="d-flex justify-content-start mb-2">
        {/* TODO: Link proper URL. */}
        <span className="d-none d-md-block">
          By providing this you are helping us process your claim.
        </span>
        <a
          className="ml-1 mt-1"
          href={process.env.REACT_APP_BASEURL+"/PolicyDocuments/INVOICE-%20EXAMPLE-Claim_Details.pdf"}
          target="_blank"
          rel="noopener noreferrer"
        >
          See sample invoice
        </a>
        <span className="d-none d-lg-block icon mt-1 ml-1">
          {" "}
          <i className="fa fa-question-circle text-secondary" />{" "}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="claim-details-form" onClick={(evt)=>evt.stopPropagation()}>
        <div className="d-flex flex-column justify-content-start">
          {this.addClaimFromHeader()}
          <Form            
            initialValues={this.props.formValues}
            onValueChange={formState => this.sendClaimFormData(formState)}
          >
          {({ formState }) => (
            <React.Fragment>
            <div className="form-elements-container">
              <DropDownSelect
                className={"form-field " + (this.props.vetClinics.length > 2 ? "" : "vet-clinic-dropdown-disable")}
                style={{ width: "100%" }}
                maxHeight={300}
                field="clinicID"
                id="claim_clinic_select"
                initialValue="select_a_clinic"
                data={this.props.vetClinics}
                search={false}
              />
              <EditText
                className="form-field"
                field="invoiceNumber"
                id="claim-invoice-number"
                type="text"
                title="Invoice Number"
                floatingTitle={true}
              />
              <EditText
                className="form-field"
                field="invoiceTotal"
                id="claim-invoice-total"
                type="text"
                title="Invoice Total"
                floatingTitle={true}
              />
              <EditText
                className="form-field"
                field="dateOfService"
                type="text"
                title="Date of Service (MM/DD/YYYY)"
                floatingTitle={true}
                mask={MaskValidateUtil.dateMask}
                validate={MaskValidateUtil.OptionalValidateDateWithNow}
                validateOnBlur
                validateOnChange={formState.errors.dateOfService}
              />
              <EditText
                className="form-field"
                field="examinationFee"
                id="claim-examination-fee"
                type="text"
                title="Examination Fee"
                floatingTitle={true}
              />
              <div
                className="text-secondary claim-question-toggle d-md-none"
                id="claim-question-toggler"
              >
                <span>Why is this important?</span>
                <span className="ml-1">
                  {" "}
                  <i className="fa fa-angle-down" />{" "}
                </span>
              </div>
              <div
                className="text-secondary claim-question-toggle d-none d-md-block"
                onClick={this.toggleFeeInfoModal.bind(this)}
              >
                <span className="link-text">Why Examination Fee is important?</span>
              </div>
            </div>
            <ModalDialog
              isOpen={this.state.feeInfoModal}
              toggle={this.toggleFeeInfoModal.bind(this)}
              modalHeader={
                <ExaminationFeeInfoModalHeader
                  toggle={this.toggleFeeInfoModal.bind(this)}
                />
                }
                modalBody={
                  <ExaminationFeeInfoModalBody
                    close={this.toggleFeeInfoModal.bind(this)}
                  />
                }
              />

              <UncontrolledCollapse toggler="#claim-question-toggler">
                <div className="claim-question-toggle">
                  <p>
                    By making the office visit, examination fee, or consultation
                    part of the pet parent's financial responsibility, we can
                    offer our complete accident and illness plan with unlimited
                    maximum payouts at a more affordable monthly premium. Think
                    about it like a copay when you see a doctor.
                  </p>
                </div>
              </UncontrolledCollapse>
              {this.props.relatedClaims.length > 0 && (
                <div className="mt-4">
                  <hr style={{ margin: "25px 0px" }} />
                  <p className="sub-title-file-claim">
                    <strong>b. Select previously covered claim</strong>
                  </p>
                  <p>
                    If this claim is for a condition that has previously been
                    submitted, please select the claim from the list below.
                  </p>
                  <TableComponent
                    ref={this.claimTableRef}
                    dataSource={this.props.relatedClaims}
                    setRelatedClaimId={this.props.setRelatedClaimId}
                  />
                </div>
              )}

              {/* Next and Skip button will not be visible in Mobile */}
              <div className="text-center d-md-flex align-items-center justify-content-center d-none add-claim-next-button-block">
                <button onClick={this.props.nextStep} className="btn btn-secondary add-details-next-step-btn">
                  Next Step{" "}
                  <span className="mt-1">
                    <i className="fa fa-angle-down" />
                  </span>{" "}
                </button>
                <button
                  className="text-secondary cancel-btn add-details-skip-now-btn text-color-violet1"
                  onClick={evt => this.props.addClaimDetailsSkip(evt)}
                >
                  Skip This Step
                </button>
              </div>
            </React.Fragment>
            )}
          </Form>
        </div>
      </div>
    );
  }
}

const ExaminationFeeInfoModalHeader = props => (
  <div className="title-container">
    <span className="modal-title">
      Why don't you cover the office visit <br />
      (examination fee)?
    </span>
  </div>
);

const ExaminationFeeInfoModalBody = props => (
  <div className="body-container">
    <p>
      By making the office visit, examination fee, or consultation part of the
      pet parent's financial responsibility, we can offer our complete accident
      and illness plan with unlimited maximum payouts at a more affordable
      monthly premium. Think about it like a copay when you see a doctor.
    </p>
    <button className="btn btn-secondary" onClick={props.close}>
      I Understand
    </button>
  </div>
);
